/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PROAUTH", "88")




export interface API25051Req {
  
  /** 用户名 */
  name?: string;
  /** 问题分类 */
  questionType?: number;
  /** 页面id */
  resourceId?: string;
  /** 问题描述 */
  desc?: string;
  /** 联系方式 */
  contactDetails?: string;
  /** 问题截图地址，多个用英文逗号分隔 */
  pictureUrls?: string;
  /** ua信息 */
  userAgent?: string;
  /** 反馈问题所在的页面地址 */
  href?: string;
};



export interface API25051Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 25051 添加问题反馈数据

export interface IUsePostAPI25051Return {
  /** 添加问题反馈数据: 接口请求状态 */
  isAPI25051Loading: boolean;
  /** 添加问题反馈数据: 接口请求返回数据 */
  dataAPI25051: API25051Res;
  /**  添加问题反馈数据: 接口数据请求方法 */
  fetchAPI25051Data:  (inputs: API25051Req, config?: YWRequestConfig) => Promise<API25051Res>;
  /** 添加问题反馈数据: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI25051 = ():IUsePostAPI25051Return => {
  let isMount = true;
  const [isAPI25051Loading, setIsAPI25051Loading] = useState(false);
  const [dataAPI25051, setDataAPI25051] = useState<API25051Res>({} as API25051Res);
  const requestUrl = `${basePath}/ywwl-admin/question/feedback/add`;

  const fetchAPI25051Data = async (inputs: API25051Req, config?: YWRequestConfig): Promise<API25051Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API25051Req>) || {}) as API25051Req;
    
  
    if ( isMount ) {
      setIsAPI25051Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API25051Res>(`${basePath}/ywwl-admin/question/feedback/add`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI25051(res || {} as API25051Res);
        setIsAPI25051Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI25051Loading(false);
      }
      return false as unknown as API25051Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI25051Loading,
    dataAPI25051,
    fetchAPI25051Data,
    requestUrl,
  }
}

